import { render, staticRenderFns } from "./PassSafeGuardResult.vue?vue&type=template&id=6efda45c&"
import script from "./PassSafeGuardResult.vue?vue&type=script&lang=js&"
export * from "./PassSafeGuardResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports